

import Vue from "vue";
import Vuex from "vuex";
import layout from "./layout";
import userStore from "./userStore";
import drawerStore from "./drawerStore";
import utilStore from "./utilStore";
import centerAndBatchStore from './centerAndBatchStore'
import messageStore from './messageStore'
import testStore from './testStore'
import questionStore from './questionStore'
import resultStore from './resultStore'
import healthStore from './healthStore'
Vue.use(Vuex);

const modules = {
  layout,
  userStore,
  app:drawerStore,
  utilStore,
  centerAndBatchStore,
  messageStore,
  testStore,
  questionStore,
  resultStore,
  healthStore
};

export default new Vuex.Store({
  state: {},
  mutations: {},
  actions: {
  },
  modules
});
